import { render, staticRenderFns } from "./systemParticularsPlace.vue?vue&type=template&id=6c189c11&scoped=true&"
import script from "./systemParticularsPlace.vue?vue&type=script&lang=js&"
export * from "./systemParticularsPlace.vue?vue&type=script&lang=js&"
import style0 from "./systemParticularsPlace.vue?vue&type=style&index=0&id=6c189c11&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c189c11",
  null
  
)

export default component.exports